/**
 * Display names for seat types
 * Used to provide consistent labeling across the application
 */
export const SEAT_DISPLAY: Record<'S' | 'M' | 'L', string> = {
  S: 'Nutzer S',
  M: 'Nutzer M',
  L: 'Nutzer L'
};

/**
 * Gets display name for a seat type
 */
export const getSeatDisplayName = (seatType: 'S' | 'M' | 'L'): string => {
  return SEAT_DISPLAY[seatType];
}; 